// @ts-nocheck
import { CssBaseline, ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import React, { createContext, useContext, useMemo, useState } from 'react';
import { Theme, themes } from '../themes';
/**
 * The theme context represents the context, in which we are finding the
 * functions for switching and rotating the theme.
 */
var ThemeContext = createContext({
    // eslint-disable-next-line
    switchTo: function (_theme) { },
});
/**
 * The following hooks are exposing the essential functions for swapping or
 * switching themes based on the inputted theme
 */
export var useThemeProvider = function () { return useContext(ThemeContext); };
/**
 * Usage:
 * ```
 *   const switch = useSwitchTheme()
 *
 *   switch(Theme.Light)
 * ```
 */
export var useSwitchTheme = function () { return useThemeProvider().switchTo; };
var ThemeProvider = function (_a) {
    var _b = _a.defaultTheme, defaultTheme = _b === void 0 ? Theme.Light : _b, children = _a.children;
    var _c = useState(defaultTheme), currentTheme = _c[0], setCurrentTheme = _c[1];
    var muiTheme = useMemo(function () { return createTheme(themes[currentTheme]); }, [currentTheme]);
    return (React.createElement(ThemeContext.Provider, { value: {
            switchTo: function (switchToTheme) { return setCurrentTheme(switchToTheme); },
        } },
        React.createElement(MuiThemeProvider, { theme: muiTheme },
            React.createElement(CssBaseline, null),
            children)));
};
export default ThemeProvider;
